<template lang="pug">
  product-listings-layout.products-collection(:sortVisible="products && products.length > 0")
    template(v-if="doc")
      //- title
      h1(slot="title") {{ doc.title }}
      //- description
      .mt-50.max-w-610.mx-auto.text-17.box-content.px-15(slot="description", v-if="doc.descriptionHtml.length")
        .product-collections__descrip.children-pb-emff(ref="descrip", v-html="descrip", :class="{'products-collection__descrip--less': !descripMore}")
        img.hidden(src='fail', @error="setDescripExceeds")
        //- (read more)
        button.btn-theme-text.text-13.flex.whitespace-no-wrap(v-if="descripExceeds", @click="descripMore = !descripMore")
          span.block.w-0.transition-opacity(:class="{'opacity-0': descripMore, 'delay-700 duration-700': !descripMore}", key="0") Read More
          span.block.transition-opacity.duration-500(:class="{'opacity-0': !descripMore, 'delay-300': descripMore}", key="1") Close
          //- span.flex.items-center(v-show="descripMore")
            svg-x.block(style="width:0.75em;height:0.75em")
            .ml-10 close

    //- (left-col)
    aside(slot="leftcol")
      product-filters-menu(:products="products", v-bind="$attrs", v-if="winIs('md')")

    //- results / not found
    transition(name="pagefade", @before-leave="scrollToTop")
      not-found-in-shop(v-if="notfound") Page Not Found
      keep-alive(v-else)
        products-results(:key="$route.fullPath", :products="products", :truncate="true")

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ProductListingsLayout from '@/components/Shop/ProductListingsLayout'
import ProductFiltersMenu from '@/components/Shop/ProductFiltersMenu'
import ProductsResults from '@/components/Shop/ProductsResults'
import NotFoundInShop from '@/components/Shop/NotFoundInShop'
import svgX from '@/components/Icons/SVG-X'
import get from 'lodash/get'
export default {
  name: 'Products__Collection',
  props: ['collection'],
  data () {
    return {
      notfound: false,
      descripExceeds: false,
      descripMore: false
    }
  },
  computed: {
    ...mapState({ sort: state => state.shop.sort }),
    ...mapGetters(['winIs']),
    doc () {
      return this.$store.state.shop.collections.find(c => c.handle === this.collection)
    },
    products () {
      const prds = this.doc && this.doc.products
      // sort by recommended ?
      if (prds && this.sort === 'recommended') {
        const recd = doc => doc.tags && doc.tags.includes('recommended') ? 0 : 1
        return prds.sort((a, b) => recd(a) - recd(b))
      }
      return prds
    },
    descrip () {
      return this.doc && this.doc.descriptionHtml.replaceAll(/<meta[^>]+>/gm, '')
    }
  },
  methods: {
    get (force = false) {
      if (this.doc && !force) return
      this.$store.dispatch('shop/getProductsFromCollection', { handle: this.collection })
        .then(() => { this.notfound = this.doc === undefined })
    },
    scrollToTop () {
      // window.scroll({ behavior: 'smooth', top: 0 })
      // >> disable for now since affecting parent routing...
    },
    setDescripExceeds () {
      const descrip = this.$refs.descrip
      // count block-level elements
      this.descripExceeds = descrip && Array.from(descrip.querySelectorAll('p,div,h1,h2,h3,h4,h5,h6,blockquote,table,ul,ol')).length
    }
  },

  // lifecycle
  created () {
    this.$emit('products', this.products)
    this.get()
  },
  watch: {
    products (arr) {
      this.$emit('products', arr)
    },
    sort () {
      this.get(true)
    }
  },
  metaInfo () {
    if (!this.doc) return
    const title = 'Hostem – ' + this.doc.title
    const img = get(this.doc, 'products[0].images.edges[0].node.transformedSrc')
    const meta = this.$store.getters.meta({ title, img, descrip: this.doc.description || false })
    meta.push({ name: 'robots', content: 'noindex,nofollow' })
    return {
      title: title,
      meta: meta,
      links: [
        { rel: 'canonical', href: process.env.VUE_APP_CANONICAL_DOMAIN + '/hostem/collections/' + this.doc.handle }
      ]
    }
  },
  components: { ProductListingsLayout, ProductFiltersMenu, ProductsResults, NotFoundInShop, svgX }
}
</script>

<style>
.product-collections__descrip {
  /* use :after for spacing because padding is not part of height :/ */
  /* ...:nth-child(n) to target just block-level elements... */
  & > *:nth-child(n):after{
    content:'';
    height:1.25em;
    display: block;
  }

  /* elements hidden behind "read more" */
  & > *:nth-child(n + 2) {
    /*animating in*/
    transition: opacity 700ms, max-height 0s;
    max-height: 100vh;
  }
  &.products-collection__descrip--less > *:nth-child(n + 2) {
    /* animating out */
    transition: opacity 500ms, max-height 0s 500ms;
    max-height:0;
    opacity:0;
    pointer-events: none;
  }
}
</style>
